export default __webpack_public_path__ + "static/media/App-store.55c7bd10.png";